export const STAT_TYPES = [
	// basketball
	"basketball--points",
	"basketball--rebounds",
	"basketball--assists",
	"basketball--pts-rebs-asts",
	"basketball--pts-rebs",
	"basketball--pts-asts",
	"basketball--rebs-asts",
	"basketball--three-point-fg", // made threes
	"basketball--double-double",
	"basketball--steals",
	"basketball--blocks",
	"basketball--steals-blocks",
	"basketball--off-rebounds",
	"basketball--def-rebounds",
	"basketball--three-point-attempts", // attempted threes
	"basketball--fg-made",
	"basketball--two-point-made",
	"basketball--two-point-attempts",
	"basketball--ft-made",
	"basketball--ft-attempts",
	"basketball--pts-blocks",
	"basketball--pts-rebs-blocks",
	"basketball--steals-turnovers",
	"basketball--steals-turnovers-blocks",
	"basketball--triple-double",
	"basketball--fouls",

	// soccer
	"soccer--shots",
	"soccer--shots-on-target",
	"soccer--goals",
	"soccer--assists",
	"soccer--goal-or-assist",
	"soccer--goals-asts",
	"soccer--goal-and-assist",
	"soccer--shots-assisted",
	"soccer--tackles",
	"soccer--passing-attempts",
	"soccer--crosses",
	"soccer--fouls-drawn",
	"soccer--fouls",
	"soccer--clearances",
	"soccer--offsides",
	"soccer--cards",
	"soccer--saves",
	"soccer--dribble-attempts",

	// cricket
	"cricket--runs",
	"cricket--wickets",
	"cricket--boundaries",
	"cricket--sixes",
	"cricket--catches",
	"cricket--stumpings",
	"cricket--run-outs",
	"cricket--points",
	"cricket--rebounds",
	"cricket--assists",
	"cricket--pts-rebs-asts",
	"cricket--pts-rebs",
	"cricket--pts-asts",
	"cricket--rebs-asts",
	"cricket--steals",
	"cricket--blocks",
	"cricket--goals",
	"cricket--made-threes",
	"cricket--fg-made",
	"cricket--double-double",
	"cricket--triple-double",
	"cricket--passing-attempts",
	"cricket--receiving-yards",
	"cricket--home-runs",
	"cricket--home-runs-yes-no",
	"cricket--earned-runs",
	"cricket--hits",
	"cricket--hits-allowed",
	"cricket--strikeouts",
	"cricket--singles",
	"cricket--bases",
	"cricket--passing-yards",
	"cricket--rushing-yards",
	"cricket--passing-touchdowns",
	"cricket--longest-passing-completion",
	"cricket--passing-completions",
	"cricket--aces",
	"cricket--games-won",
	"cricket--touchdowns",
	"cricket--receptions",
	"cricket--passing-rushing-yards",
	"cricket--rushing-receiving-yards",
	"cricket--longest-reception",
	"cricket--longest-rush",

	// tennis
	"tennis--aces",
	"tennis--games-won",
	"tennis--points",
	"tennis--rebounds",
	"tennis--assists",
	"tennis--pts-rebs-asts",
	"tennis--pts-rebs",
	"tennis--pts-asts",
	"tennis--rebs-asts",
	"tennis--steals",
	"tennis--blocks",
	"tennis--goals",
	"tennis--made-threes",
	"tennis--fg-made",
	"tennis--double-double",
	"tennis--triple-double",
	"tennis--passing-attempts",
	"tennis--receiving-yards",
	"tennis--home-runs",
	"tennis--home-runs-yes-no",
	"tennis--earned-runs",
	"tennis--hits",
	"tennis--hits-allowed",
	"tennis--strikeouts",
	"tennis--singles",
	"tennis--bases",
	"tennis--passing-yards",
	"tennis--rushing-yards",
	"tennis--passing-touchdowns",
	"tennis--longest-passing-completion",
	"tennis--passing-completions",
	"tennis--touchdowns",
	"tennis--runs",
	"tennis--receptions",
	"tennis--passing-rushing-yards",
	"tennis--rushing-receiving-yards",
	"tennis--longest-reception",
	"tennis--longest-rush",

	// baseball
	"baseball--hits",
	"baseball--bases",
	"baseball--home-runs",
	"baseball--rbis",
	"baseball--runs",
	"baseball--strikeouts",
	"baseball--batting-strikeouts",
	"baseball--hits-allowed",
	"baseball--earned-runs",
	"baseball--first-inning-earned-runs",
	"baseball--pitches-thrown",
	"baseball--pitches-faced",
	"baseball--outs",
	"baseball--stolen-bases",
	"baseball--hits-runs-rbis",
	"baseball--singles",
	"baseball--doubles",
	"baseball--triples",
	"baseball--walks",
	"baseball--batting-walks",

	// football
	"football--passing-yards",
	"football--passing-touchdowns",
	"football--passing-attempts",
	"football--passing-completions",
	"football--rushing-yards",
	"football--rushing-attempts",
	"football--rushing-touchdowns",
	"football--receiving-yards",
	"football--receptions",
	"football--targets",
	"football--receiving-touchdowns",
	"football--touchdowns",
	"football--passing-rushing-yards",
	"football--rushing-receiving-yards",
	"football--kicking-points",
	"football--field-goals-made",
	"football--extra-points-made",
	"football--sacks",
	"football--tackles-assists",
	"football--assists",
	"football--interceptions",
	"football--defensive-interceptions",
	"football--pass-deflections",
	"football--punts",
	"football--longest-reception",
	"football--longest-rush",
	"football--longest-passing-completion",

	// esports
	"esports--map-1-kills",
	"esports--maps-1-2-kills",
	"esports--maps-1-3-kills",
	"esports--map-2-kills",
	"esports--map-1-headshots",
	"esports--maps-1-2-headshots",
	"esports--maps-1-3-headshots",
	"esports--map-2-headshots",
] as const;

export type StatType = (typeof STAT_TYPES)[number];
type StatTypeInfo = { short_title: string; full_title_template: string };

// This will fail to compile if any stat type from STAT_TYPES is missing
export const STAT_TYPE_INFO = {
	// BASKETBALL
	"basketball--points": {
		short_title: "Pts",
		full_title_template: "{Player} - Points",
	},
	"basketball--assists": {
		short_title: "Ast",
		full_title_template: "{Player} - Assists",
	},
	"basketball--rebounds": {
		short_title: "Reb",
		full_title_template: "{Player} - Rebounds",
	},
	"basketball--off-rebounds": {
		short_title: "OReb",
		full_title_template: "{Player} - Offensive Rebounds",
	},
	"basketball--def-rebounds": {
		short_title: "DReb",
		full_title_template: "{Player} - Defensive Rebounds",
	},
	"basketball--rebs-asts": {
		short_title: "Reb+Ast",
		full_title_template: "{Player} - Rebounds + Assists",
	},
	"basketball--pts-asts": {
		short_title: "Pts+Ast",
		full_title_template: "{Player} - Points + Assists",
	},
	"basketball--pts-rebs": {
		short_title: "Pts+Reb",
		full_title_template: "{Player} - Points + Rebounds",
	},
	"basketball--pts-rebs-asts": {
		short_title: "PRA",
		full_title_template: "{Player} - Points + Rebounds + Assists",
	},
	"basketball--pts-blocks": {
		short_title: "Pts+Blk",
		full_title_template: "{Player} - Points + Blocks",
	},
	"basketball--pts-rebs-blocks": {
		short_title: "Pts+Reb+Blk",
		full_title_template: "{Player} - Points + Rebounds + Blocks",
	},
	"basketball--steals": {
		short_title: "Stl",
		full_title_template: "{Player} - Steals",
	},
	"basketball--blocks": {
		short_title: "Blk",
		full_title_template: "{Player} - Blocks",
	},
	"basketball--steals-blocks": {
		short_title: "Stl+Blk",
		full_title_template: "{Player} - Steals + Blocks",
	},
	"basketball--steals-turnovers": {
		short_title: "Stl+TO",
		full_title_template: "{Player} - Steals + Turnovers",
	},
	"basketball--steals-turnovers-blocks": {
		short_title: "Stl+TO+Blk",
		full_title_template: "{Player} - Steals + Turnovers + Blocks",
	},
	"basketball--double-double": {
		short_title: "DD",
		full_title_template: "{Player} - Double-Double",
	},
	"basketball--triple-double": {
		short_title: "TD",
		full_title_template: "{Player} - Triple-Double",
	},
	"basketball--three-point-fg": {
		short_title: "3PM",
		full_title_template: "{Player} - 3-Point FG Made",
	},
	"basketball--three-point-attempts": {
		short_title: "3PA",
		full_title_template: "{Player} - 3-Point Attempts",
	},
	"basketball--fg-made": {
		short_title: "FGM",
		full_title_template: "{Player} - Field Goals Made",
	},
	"basketball--two-point-made": {
		short_title: "2PM",
		full_title_template: "{Player} - 2-Point FG Made",
	},
	"basketball--two-point-attempts": {
		short_title: "2PA",
		full_title_template: "{Player} - 2-Point Attempts",
	},
	"basketball--ft-made": {
		short_title: "FTM",
		full_title_template: "{Player} - Free Throws Made",
	},
	"basketball--ft-attempts": {
		short_title: "FTA",
		full_title_template: "{Player} - Free Throw Attempts",
	},
	"basketball--fouls": {
		short_title: "PF",
		full_title_template: "{Player} - Fouls",
	},

	// SOCCER
	"soccer--goals": {
		short_title: "Gls",
		full_title_template: "{Player} - Goals",
	},
	"soccer--goals-asts": {
		short_title: "G+A",
		full_title_template: "{Player} - Goals + Assists",
	},
	"soccer--assists": {
		short_title: "Ast",
		full_title_template: "{Player} - Assists",
	},
	"soccer--shots": {
		short_title: "Sht",
		full_title_template: "{Player} - Shots",
	},
	"soccer--shots-on-target": {
		short_title: "SOT",
		full_title_template: "{Player} - Shots on Target",
	},
	"soccer--shots-assisted": {
		short_title: "AstSht",
		full_title_template: "{Player} - Assisted Shots",
	},
	"soccer--tackles": {
		short_title: "Tkl",
		full_title_template: "{Player} - Tackles",
	},
	"soccer--fouls": {
		short_title: "Fls",
		full_title_template: "{Player} - Fouls",
	},
	"soccer--fouls-drawn": {
		short_title: "FD",
		full_title_template: "{Player} - Fouls Drawn",
	},
	"soccer--offsides": {
		short_title: "Off",
		full_title_template: "{Player} - Offsides",
	},
	"soccer--passing-attempts": {
		short_title: "PassAtt",
		full_title_template: "{Player} - Pass Attempts",
	},
	"soccer--clearances": {
		short_title: "Clr",
		full_title_template: "{Player} - Clearances",
	},
	"soccer--crosses": {
		short_title: "Crs",
		full_title_template: "{Player} - Crosses",
	},
	"soccer--dribble-attempts": {
		short_title: "Drb",
		full_title_template: "{Player} - Dribble Attempts",
	},
	"soccer--cards": {
		short_title: "Crd",
		full_title_template: "{Player} - Cards",
	},
	"soccer--saves": {
		short_title: "Sav",
		full_title_template: "{Player} - Saves",
	},
	"soccer--goal-or-assist": {
		short_title: "G/A",
		full_title_template: "{Player} - To Score or Assist",
	},
	"soccer--goal-and-assist": {
		short_title: "G&A",
		full_title_template: "{Player} - To Score and Assist",
	},

	// CRICKET
	"cricket--runs": {
		short_title: "Runs",
		full_title_template: "{Player} - Runs",
	},
	"cricket--wickets": {
		short_title: "Wkts",
		full_title_template: "{Player} - Wickets",
	},
	"cricket--boundaries": {
		short_title: "4s",
		full_title_template: "{Player} - Boundaries",
	},
	"cricket--sixes": {
		short_title: "6s",
		full_title_template: "{Player} - Sixes",
	},
	"cricket--catches": {
		short_title: "Ct",
		full_title_template: "{Player} - Catches",
	},
	"cricket--stumpings": {
		short_title: "St",
		full_title_template: "{Player} - Stumpings",
	},
	"cricket--run-outs": {
		short_title: "RO",
		full_title_template: "{Player} - Run Outs",
	},
	"cricket--points": {
		short_title: "Pts",
		full_title_template: "{Player} - Points",
	},
	"cricket--assists": {
		short_title: "Ast",
		full_title_template: "{Player} - Assists",
	},
	"cricket--rebounds": {
		short_title: "Reb",
		full_title_template: "{Player} - Rebounds",
	},
	"cricket--pts-rebs": {
		short_title: "Pts+Reb",
		full_title_template: "{Player} - Points + Rebounds",
	},
	"cricket--pts-asts": {
		short_title: "Pts+Ast",
		full_title_template: "{Player} - Points + Assists",
	},
	"cricket--pts-rebs-asts": {
		short_title: "PRA",
		full_title_template: "{Player} - Points + Rebounds + Assists",
	},
	"cricket--rebs-asts": {
		short_title: "Reb+Ast",
		full_title_template: "{Player} - Rebounds + Assists",
	},
	"cricket--steals": {
		short_title: "Stl",
		full_title_template: "{Player} - Steals",
	},
	"cricket--blocks": {
		short_title: "Blk",
		full_title_template: "{Player} - Blocks",
	},
	"cricket--goals": {
		short_title: "Gls",
		full_title_template: "{Player} - Goals",
	},
	"cricket--made-threes": {
		short_title: "3PM",
		full_title_template: "{Player} - 3-Point FG Made",
	},
	"cricket--fg-made": {
		short_title: "FGM",
		full_title_template: "{Player} - Field Goals Made",
	},
	"cricket--double-double": {
		short_title: "DD",
		full_title_template: "{Player} - Double-Double",
	},
	"cricket--triple-double": {
		short_title: "TD",
		full_title_template: "{Player} - Triple-Double",
	},
	"cricket--passing-attempts": {
		short_title: "PassAtt",
		full_title_template: "{Player} - Pass Attempts",
	},
	"cricket--receiving-yards": {
		short_title: "RecYds",
		full_title_template: "{Player} - Receiving Yards",
	},
	"cricket--home-runs": {
		short_title: "HR",
		full_title_template: "{Player} - Home Runs",
	},
	"cricket--home-runs-yes-no": {
		short_title: "HR",
		full_title_template: "{Player} - Home Run",
	},
	"cricket--earned-runs": {
		short_title: "ER",
		full_title_template: "{Player} - Earned Runs",
	},
	"cricket--hits": {
		short_title: "H",
		full_title_template: "{Player} - Hits",
	},
	"cricket--hits-allowed": {
		short_title: "HA",
		full_title_template: "{Player} - Hits Allowed",
	},
	"cricket--strikeouts": {
		short_title: "K",
		full_title_template: "{Player} - Strikeouts",
	},
	"cricket--singles": {
		short_title: "1B",
		full_title_template: "{Player} - Singles",
	},
	"cricket--bases": {
		short_title: "TB",
		full_title_template: "{Player} - Bases",
	},
	"cricket--passing-yards": {
		short_title: "PassYds",
		full_title_template: "{Player} - Passing Yards",
	},
	"cricket--rushing-yards": {
		short_title: "RushYds",
		full_title_template: "{Player} - Rushing Yards",
	},
	"cricket--passing-touchdowns": {
		short_title: "PassTD",
		full_title_template: "{Player} - Passing Touchdowns",
	},
	"cricket--longest-passing-completion": {
		short_title: "LngPass",
		full_title_template: "{Player} - Longest Passing Completion",
	},
	"cricket--passing-completions": {
		short_title: "Cmp",
		full_title_template: "{Player} - Passing Completions",
	},
	"cricket--aces": {
		short_title: "Aces",
		full_title_template: "{Player} - Aces",
	},
	"cricket--longest-reception": {
		short_title: "LngRec",
		full_title_template: "{Player} - Longest Reception",
	},
	"cricket--games-won": {
		short_title: "GW",
		full_title_template: "{Player} - Games Won",
	},
	"cricket--passing-rushing-yards": {
		short_title: "Pass+Rush",
		full_title_template: "{Player} - Passing + Rushing Yards",
	},
	"cricket--touchdowns": {
		short_title: "TD",
		full_title_template: "{Player} - Touchdowns",
	},
	"cricket--rushing-receiving-yards": {
		short_title: "Rush+Rec",
		full_title_template: "{Player} - Rushing + Receiving Yards",
	},
	"cricket--receptions": {
		short_title: "Rec",
		full_title_template: "{Player} - Receptions",
	},
	"cricket--longest-rush": {
		short_title: "LngRush",
		full_title_template: "{Player} - Longest Rush",
	},

	// TENNIS
	"tennis--points": {
		short_title: "Pts",
		full_title_template: "{Player} - Points",
	},
	"tennis--assists": {
		short_title: "Ast",
		full_title_template: "{Player} - Assists",
	},
	"tennis--rebounds": {
		short_title: "Reb",
		full_title_template: "{Player} - Rebounds",
	},
	"tennis--pts-rebs": {
		short_title: "Pts+Reb",
		full_title_template: "{Player} - Points + Rebounds",
	},
	"tennis--pts-asts": {
		short_title: "Pts+Ast",
		full_title_template: "{Player} - Points + Assists",
	},
	"tennis--pts-rebs-asts": {
		short_title: "PRA",
		full_title_template: "{Player} - Points + Rebounds + Assists",
	},
	"tennis--rebs-asts": {
		short_title: "Reb+Ast",
		full_title_template: "{Player} - Rebounds + Assists",
	},
	"tennis--steals": {
		short_title: "Stl",
		full_title_template: "{Player} - Steals",
	},
	"tennis--blocks": {
		short_title: "Blk",
		full_title_template: "{Player} - Blocks",
	},
	"tennis--goals": {
		short_title: "Gls",
		full_title_template: "{Player} - Goals",
	},
	"tennis--made-threes": {
		short_title: "3PM",
		full_title_template: "{Player} - 3-Point FG Made",
	},
	"tennis--fg-made": {
		short_title: "FGM",
		full_title_template: "{Player} - Field Goals Made",
	},
	"tennis--double-double": {
		short_title: "DD",
		full_title_template: "{Player} - Double-Double",
	},
	"tennis--triple-double": {
		short_title: "TD",
		full_title_template: "{Player} - Triple-Double",
	},
	"tennis--passing-attempts": {
		short_title: "PassAtt",
		full_title_template: "{Player} - Pass Attempts",
	},
	"tennis--receiving-yards": {
		short_title: "RecYds",
		full_title_template: "{Player} - Receiving Yards",
	},
	"tennis--home-runs": {
		short_title: "HR",
		full_title_template: "{Player} - Home Runs",
	},
	"tennis--home-runs-yes-no": {
		short_title: "HR",
		full_title_template: "{Player} - Home Run",
	},
	"tennis--earned-runs": {
		short_title: "ER",
		full_title_template: "{Player} - Earned Runs",
	},
	"tennis--hits": {
		short_title: "H",
		full_title_template: "{Player} - Hits",
	},
	"tennis--hits-allowed": {
		short_title: "HA",
		full_title_template: "{Player} - Hits Allowed",
	},
	"tennis--strikeouts": {
		short_title: "K",
		full_title_template: "{Player} - Strikeouts",
	},
	"tennis--singles": {
		short_title: "1B",
		full_title_template: "{Player} - Singles",
	},
	"tennis--bases": {
		short_title: "TB",
		full_title_template: "{Player} - Bases",
	},
	"tennis--passing-yards": {
		short_title: "PassYds",
		full_title_template: "{Player} - Passing Yards",
	},
	"tennis--rushing-yards": {
		short_title: "RushYds",
		full_title_template: "{Player} - Rushing Yards",
	},
	"tennis--passing-touchdowns": {
		short_title: "PassTD",
		full_title_template: "{Player} - Passing Touchdowns",
	},
	"tennis--longest-passing-completion": {
		short_title: "LngPass",
		full_title_template: "{Player} - Longest Passing Completion",
	},
	"tennis--passing-completions": {
		short_title: "Cmp",
		full_title_template: "{Player} - Passing Completions",
	},
	"tennis--aces": {
		short_title: "Aces",
		full_title_template: "{Player} - Aces",
	},
	"tennis--longest-reception": {
		short_title: "LngRec",
		full_title_template: "{Player} - Longest Reception",
	},
	"tennis--games-won": {
		short_title: "GW",
		full_title_template: "{Player} - Games Won",
	},
	"tennis--passing-rushing-yards": {
		short_title: "Pass+Rush",
		full_title_template: "{Player} - Passing + Rushing Yards",
	},
	"tennis--touchdowns": {
		short_title: "TD",
		full_title_template: "{Player} - Touchdowns",
	},
	"tennis--runs": {
		short_title: "Runs",
		full_title_template: "{Player} - Runs",
	},
	"tennis--rushing-receiving-yards": {
		short_title: "Rush+Rec",
		full_title_template: "{Player} - Rushing + Receiving Yards",
	},
	"tennis--receptions": {
		short_title: "Rec",
		full_title_template: "{Player} - Receptions",
	},
	"tennis--longest-rush": {
		short_title: "LngRush",
		full_title_template: "{Player} - Longest Rush",
	},
	// BASEBALL
	"baseball--hits": {
		short_title: "H",
		full_title_template: "{Player} - Hits",
	},
	"baseball--bases": {
		short_title: "TB",
		full_title_template: "{Player} - Total Bases",
	},
	"baseball--home-runs": {
		short_title: "HR",
		full_title_template: "{Player} - Home Runs",
	},
	"baseball--rbis": {
		short_title: "RBI",
		full_title_template: "{Player} - RBIs",
	},
	"baseball--runs": {
		short_title: "R",
		full_title_template: "{Player} - Runs",
	},
	"baseball--strikeouts": {
		short_title: "K",
		full_title_template: "{Player} - Strikeouts",
	},
	"baseball--batting-strikeouts": {
		short_title: "K",
		full_title_template: "{Player} - Batting Strikeouts",
	},
	"baseball--hits-allowed": {
		short_title: "HA",
		full_title_template: "{Player} - Hits Allowed",
	},
	"baseball--earned-runs": {
		short_title: "ER",
		full_title_template: "{Player} - Earned Runs",
	},
	"baseball--first-inning-earned-runs": {
		short_title: "1st Inn. ER",
		full_title_template: "{Player} - 1st Inning Earned Runs",
	},
	"baseball--pitches-thrown": {
		short_title: "PT",
		full_title_template: "{Player} - Pitches Thrown",
	},
	"baseball--pitches-faced": {
		short_title: "PF",
		full_title_template: "{Player} - Pitches Faced",
	},
	"baseball--outs": {
		short_title: "Outs",
		full_title_template: "{Player} - Outs Recorded",
	},
	"baseball--stolen-bases": {
		short_title: "SB",
		full_title_template: "{Player} - Stolen Bases",
	},
	"baseball--hits-runs-rbis": {
		short_title: "H+R+RBI",
		full_title_template: "{Player} - Hits + Runs + RBIs",
	},
	"baseball--singles": {
		short_title: "1B",
		full_title_template: "{Player} - Singles",
	},
	"baseball--doubles": {
		short_title: "2B",
		full_title_template: "{Player} - Doubles",
	},
	"baseball--triples": {
		short_title: "3B",
		full_title_template: "{Player} - Triples",
	},
	"baseball--walks": {
		short_title: "BB",
		full_title_template: "{Player} - Walks Allowed",
	},
	"baseball--batting-walks": {
		short_title: "BB",
		full_title_template: "{Player} - Batting Walks",
	},

	// FOOTBALL
	"football--passing-yards": {
		short_title: "PassYds",
		full_title_template: "{Player} - Passing Yards",
	},
	"football--passing-touchdowns": {
		short_title: "PassTD",
		full_title_template: "{Player} - Passing Touchdowns",
	},
	"football--passing-attempts": {
		short_title: "Pass Att",
		full_title_template: "{Player} - Passing Attempts",
	},
	"football--passing-completions": {
		short_title: "Cmp",
		full_title_template: "{Player} - Passing Completions",
	},
	"football--rushing-yards": {
		short_title: "RushYds",
		full_title_template: "{Player} - Rushing Yards",
	},
	"football--rushing-attempts": {
		short_title: "Rush Att",
		full_title_template: "{Player} - Rushing Attempts",
	},
	"football--rushing-touchdowns": {
		short_title: "RushTD",
		full_title_template: "{Player} - Rushing Touchdowns",
	},
	"football--receiving-yards": {
		short_title: "RecYds",
		full_title_template: "{Player} - Receiving Yards",
	},
	"football--receptions": {
		short_title: "Rec",
		full_title_template: "{Player} - Receptions",
	},
	"football--targets": {
		short_title: "Tgt",
		full_title_template: "{Player} - Targets",
	},
	"football--receiving-touchdowns": {
		short_title: "RecTD",
		full_title_template: "{Player} - Receiving Touchdowns",
	},
	"football--touchdowns": {
		short_title: "TD",
		full_title_template: "{Player} - Touchdowns",
	},
	"football--passing-rushing-yards": {
		short_title: "Pass+Rush",
		full_title_template: "{Player} - Passing + Rushing Yards",
	},
	"football--rushing-receiving-yards": {
		short_title: "Rush+Rec",
		full_title_template: "{Player} - Rushing + Receiving Yards",
	},
	"football--kicking-points": {
		short_title: "KickPts",
		full_title_template: "{Player} - Kicking Points",
	},
	"football--field-goals-made": {
		short_title: "FGM",
		full_title_template: "{Player} - Field Goals Made",
	},
	"football--extra-points-made": {
		short_title: "XPM",
		full_title_template: "{Player} - Extra Points Made",
	},
	"football--sacks": {
		short_title: "Sacks",
		full_title_template: "{Player} - Sacks",
	},
	"football--tackles-assists": {
		short_title: "Tkl+Ast",
		full_title_template: "{Player} - Tackles + Assists",
	},
	"football--assists": {
		short_title: "Ast",
		full_title_template: "{Player} - Assists",
	},
	"football--interceptions": {
		short_title: "INT",
		full_title_template: "{Player} - Interceptions",
	},
	"football--defensive-interceptions": {
		short_title: "Def INT",
		full_title_template: "{Player} - Defensive Interceptions",
	},
	"football--pass-deflections": {
		short_title: "PD",
		full_title_template: "{Player} - Pass Deflections",
	},
	"football--punts": {
		short_title: "Punts",
		full_title_template: "{Player} - Punts",
	},
	"football--longest-reception": {
		short_title: "LngRec",
		full_title_template: "{Player} - Longest Reception",
	},
	"football--longest-rush": {
		short_title: "LngRush",
		full_title_template: "{Player} - Longest Rush",
	},
	"football--longest-passing-completion": {
		short_title: "LngPass",
		full_title_template: "{Player} - Longest Passing Completion",
	},

	// ESPORTS
	"esports--map-1-kills": {
		short_title: "M1 K",
		full_title_template: "{Player} - Map 1 Kills",
	},
	"esports--maps-1-2-kills": {
		short_title: "M1-2 K",
		full_title_template: "{Player} - Maps 1-2 Kills",
	},
	"esports--maps-1-3-kills": {
		short_title: "M1-3 K",
		full_title_template: "{Player} - Maps 1-3 Kills",
	},
	"esports--map-2-kills": {
		short_title: "M2 K",
		full_title_template: "{Player} - Map 2 Kills",
	},
	"esports--map-1-headshots": {
		short_title: "M1 HS",
		full_title_template: "{Player} - Map 1 Headshots",
	},
	"esports--maps-1-2-headshots": {
		short_title: "M1-2 HS",
		full_title_template: "{Player} - Maps 1-2 Headshots",
	},
	"esports--maps-1-3-headshots": {
		short_title: "M1-3 HS",
		full_title_template: "{Player} - Maps 1-3 Headshots",
	},
	"esports--map-2-headshots": {
		short_title: "M2 HS",
		full_title_template: "{Player} - Map 2 Headshots",
	},
} as const satisfies Record<StatType, StatTypeInfo>;
